import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { landingPageDesignsKeys } from './landingPageDesignsKeys';
import { ILandingPageDesignResponse } from 'app/pages/admin/landing-pages-v2/types';

const getSingleLandingPageDesign = async (
  id: number | null
): Promise<ILandingPageDesignResponse> => {
  return (await EXPRESS_API.get(`/superadmin/landing-page-designs/${id}`)).data;
};

export const useQuerySingleLandingPageDesign = (
  templateId: number | null,
  enabled: boolean
) => {
  return useQuery(
    landingPageDesignsKeys.single(templateId),
    () => getSingleLandingPageDesign(templateId),
    {
      refetchOnMount: true,
      staleTime: 0,
      enabled,
      onError: () => {
        errorToast({
          title: `We're currently experiencing difficulties fetching design with ID: ${templateId}`,
        });
      },
    }
  );
};
